import React, {KeyboardEventHandler, useCallback, useMemo, useState} from 'react'
import EntitySelectorSearchInput from "../../search/search-input"
import EntitySelectorSearchRow from "../../search/search-row"
import Button from "../../../buttons/gd-button/gd-button-ui5-new"
import {EntitySelectorListType} from "../../selector"

type Props = {
    listType            : EntitySelectorListType

    onKeyDown           : KeyboardEventHandler
    onSearchChanged     : {(value:string):void}
    onTypeChanged       : {(type:EntitySelectorListType):void}
}

const debug = false
// const debug = "EntitySelectorProjectsSearch"

export default function EntitySelectorProjectsSearch (props:Props) {
    debug && console.log(debug, 'render', props)

    const [search, setSearch] = useState('')

    const delayedSearch = useMemo(()=>_.debounce((search)=>{
        debug && console.log(debug, 'delayedSearch', search)
        props.onSearchChanged(search)
    }, 500), [])

    const onSearchChange = useCallback((value:string)=>{
        debug && console.log(debug, 'onSearchChange', value)
        setSearch(value)
        delayedSearch(value)
    }, [])

    const onSearchCancel = useCallback(()=>{
        setSearch('')
        delayedSearch('')
    }, [])

    const onChangeType = useCallback((type:EntitySelectorListType)=>{
        onSearchCancel()
        props.onTypeChanged(type)
    }, [])

    const isBrowse = !search /*&& props.listType === EntitySelectorListType.BROWSE*/

    return (
        <EntitySelectorSearchRow>
            <EntitySelectorSearchInput search           = {search}
                                       placeholder      = "Search by name"
                                       onKeyDown        = {props.onKeyDown}
                                       onSearchChange   = {onSearchChange}
                                       onSearchCancel   = {onSearchCancel}/>

            <Button className   = "m-l-10 p-l-8 p-r-8"
                    type        = {isBrowse ? 'selected' : 'on-gray'}
                    icon        = 'i5-folder-tree'
                    label       = 'Browse'
                    onClick     = {()=>{onChangeType(EntitySelectorListType.BROWSE)}}/>
        </EntitySelectorSearchRow>
    )
}
